import * as types from '../mutation-types';
import mapApi from '../../api/map';

const initialState = {
  apiToken: null,
  couponCode: null,
};

const actions = {
  checkCoupon(_, { couponCode, activeProjectSlug }) {
    return mapApi.checkCoupon({ couponCode, activeProjectSlug }).then(res => res.coupon, () => false);
  },
};

const mutations = {
  [types.SAVE_PURCHASE](state, payload) {
    state.apiToken = payload.apiToken;
  },
  [types.RESET_PURCHASE](state) {
    state.apiToken = null;
  },
  [types.SAVE_COUPON](state, payload) {
    state.couponCode = payload;
  },
  [types.RESET_COUPON](state) {
    state.couponCode = null;
  },
};

export default {
  state: initialState,
  actions,
  mutations,
};
